export default {
  helloWorld: 'Hello, World!',
  routes: {
    pathPrefix: 'en',
    basePath: 'car-insurance/quote',
    motorbikeBasePath: 'motorbike-insurance/quote',
    insuranceRequest: '',
    agent: 'agent',
    productSelect: 'premiums',
    options: 'change-cover',
    vehicleSelect: 'carsearch',
    vehicleSelectComfort: 'comfort',
    vehicleSelectVehicleNumber: 'vehicleregistrationcertificate',
    vehicleSelected: 'selectedvehicle',
    vehicleData: 'cardetails',
    owner: 'owner',
    personalData: 'personal-details',
    checkout: 'check-entry',
    offer: 'request-quote',
    referral: 'referral',
    confirmation: 'confirmation',
    infoLater: 'info-later',
    finish: 'complete',
    declined: 'rejection',
    rejected: 'processing',
    offerExpired: 'expired',
    error: 'error',
    maintenance: 'maintenance',
    playground: 'playground',
  },
  errors: {
    graphqlQueryBase: 'An error occurred. Please try again.',
    paper: 'in paper form',
    electronic: 'electronically',
    vehicleNotFound: 'Vehicle not found. Please check your entry or use the vehicle search.',
    technicalError: 'A technical error occurred. Please try again.',
    technicalErrorLater: 'Sorry, a technical error occurred that will take some time to resolve. Please try the calculation again later.',
    maintenance: 'The system is currently in maintenance mode. Please try the calculation again later.',
    declined: "Unfortunately, we can't offer you insurance for your car at present",
  },
  basics: {
    age: 'Age',
    plz: 'Postcode',
    gender: 'Title',
    genderFemale: 'Ms',
    genderMale: 'Mr',
    genderCompany: 'Company',
    firstName: 'First name',
    lastName: 'Surname',
    street: 'Street',
    houseNumber: 'House number',
    city: 'Town/city',
    email: 'E-mail',
    phone: 'Phone',
    dateOfBirth: 'Date of birth',
    licence: 'Driving licence',
    nationality: 'Nationality',
    swiss: 'Swiss',
    others: 'Other',
    chooseOption: 'Please select',
    noResultsOption: 'No results',
    unknownOption: "Don't know",
    selectProduct: 'Select product',
    customizeCoverage: 'Customise cover',
    vehicle: 'Vehicle',
    ovner: 'Owner',
    enterContract: 'Conclude contract',
    continue: 'Next',
    back: 'Back',
    reset: 'Reset details',
    yes: 'Yes',
    no: 'No',
    notWanted: "Don't want",
    datePlaceholder: 'DD.MM.YYYY',
    yearPlaceholder: 'YYYY',
    company: 'Name of company',
    uid: 'VAT no.',
    industry: 'Industry',
    vehicleType: 'Driving a',
    flexDrive: 'FlexDrive',
    basisDrive: 'BasisDrive',
  },
  start: {
    head: {
      h1: 'Your new car insurance',
      h3: 'Calculate new premium for your vehicle insurance now',
      p: "Top products, fully digital with a personal touch – that's Simpego.",
      list: {
        car: 'Car',
        van: 'Van',
        vanRegisteredAsCar: 'Company vehicles',
        motorbike: 'Motorbikes',
      },
    },
    form: {
      personal: {
        h3: 'Personal details',
        age1: 'I am',
        age2: 'years old.',
        plz1: 'My postcode is',
        otherNationality: 'Other nationality',
        customerTypePerson: 'Individual',
        customerTypeCompany: 'Company',
        companyZip: 'Postcode of company',
        industry: 'Industry',
        industries: {
          industry1: 'Retail, finance, consulting, real estate, IT',
          industry2: 'Hospitality, travel & tourism, leisure',
          industry3: 'Construction, workshop, mechanical engineering',
          industry4: 'Manufacturing, disposal, cleaning',
          industry5: 'Postage/courier/delivery/transportation',
          industry6: 'Shipping and aviation',
          industry7: 'Vehicle rental',
          industry8: 'Medical care, care homes, veterinary',
          industry9: 'Music, media, publishing, TV, advertising',
          industry10: 'Public institutions, museums, churches, associations',
          industry11: 'Agriculture, water, energy, chemistry',
          industry12: 'Emergency services',
          industry13: 'Other',
        },
        ageOrYear: 'Age / year of birth',
        zip: 'Postcode',
      },
      car: {
        h3: 'Vehicle details',
        searchmode1: 'Vehicle search',
        searchmode2: 'Enter vehicle reg. certificate',
        initialRegistrationYear: 'First registered (year)',
        brand: 'The make of my vehicle is',
        model: 'The model is',
        fuelType: 'It runs on (fuel type)',
        powerRange: 'Its horsepower is',
        typeCertificateNumber: 'My vehicle reg. certificate number is',
        typeCertificateNumber_placeholder: '24th digit on the vehicle reg. certificate',
        vehicleSearchError: 'No results found.',
      },
      startOfInsurance: {
        h3: 'Start of insurance',
        startOfInsurance: 'I would like my insurance to start on',
      },
      sendButton: 'Show premiums',
    },
  },
  insurancerequest: {
    annoPrice: '/year',
    from: 'from',
    footerBackText: 'recalculate',
    declinedHeadline: "Can't calculate price. Reason:",
  },
  customizeCoverage: {
    form: {
      deductible: {
        h3: 'Liability',
        h3Hint: 'Compulsory liability insurance covers damage to third-party property or persons caused with your vehicle when driven by you or by a person for whom you are responsible. This applies in the following situations:<br><br> - When operating the vehicle;<br> - For road accidents caused by the vehicle when it is not in operation;<br> - When providing assistance after accidents involving the vehicle;<br> - When entering and exiting the vehicle, opening and closing movable vehicle parts, or attaching and detaching a trailer or another vehicle.<br><br>Simpego will pay out for legitimate claims and will defend unjustified claims against the insured. Cover is limited to CHF 100 million per event, including any claim-related interest, legal fees and court costs. Deductibles for drivers under the age of 25: M + CHF 1´500, L + CHF 1´200 and XL + CHF 1´000.',
        customizeCoverage: {
          label: 'Deductible in CHF',
          infoText: 'Select your deductible. This is the amount you have to pay yourself in the event of a claim.',
          inputHint: 'Enter an amount between CHF {min} and {max}',
        },
        customizeCoverage25: {
          label: 'Deductible for undeclared drivers under the age of 25',
          infoText: 'This deductible is waived if drivers under the age of 25 have been declared or if you yourself are under 25 years old.',
          value: '+ CHF {value}',
        },
        fieldName: 'Deductible',
      },
      comprehensive: {
        h3: 'Comprehensive',
        comprehensiveOptions: {
          label: 'Choose comprehensive',
          infoText: 'Fully comprehensive insurance (partially comprehensive and collision cover)<br><br> In addition to all the benefits of partially comprehensive insurance, the policy also covers damage caused by sudden, violent, mechanical, involuntary, external influences (e.g. collision, impact, crashing or overturning).<br><br> Partially comprehensive insurance<br> Covers damage caused by fire, natural disasters, snowslides, theft, collision with an animal, marten damage, windscreen damage (glass breakage Basis) and vandalism, as well as damage resulting from crashes and emergency landings of aircraft and spacecraft (or parts thereof).',
        },
        partially_comprehensive: {
          label: 'Partially comprehensive deductible in CHF',
          infoText: 'Select your deductible. This is the amount you have to pay yourself in the event of a claim.',
          inputHint: 'Enter an amount between CHF {min} and {max}',
        },
        fully_comprehensive: {
          label: 'Collision deductible in CHF',
          infoText: 'Select your deductible. This is the amount you have to pay yourself in the event of a claim.',
          inputHint: 'Enter an amount between CHF {min} and {max}',
        },
        deductible_under_25: {
          label: 'Deductible for undeclared drivers under the age of 25',
          infoText: 'This deductible is waived if drivers under the age of 25 have been declared or if you yourself are under 25 years old.',
          value: '+ CHF {value}',
        },
      },
      comprehensiveOptions: {
        h3: 'Extras for comprehensive insurance',
        park_damage: {
          label: 'Parking damage cover',
          infoText: 'Parking damage Basis<br> Damage to the parked vehicle caused by unknown third parties is insured up to CHF 2´000 per event with the selected deductible. <br><br> Parking damage Plus<br> Damage to the parked vehicle caused by unknown third parties is insured up to an unlimited amount with the selected deductible. <br><br> A maximum of two claims per calendar year are insured.',
        },
        park_damage_deductible: {
          label: 'Parking damage deductible in CHF',
          infoText: 'Select your deductible. This is the amount you have to pay yourself in the event of a claim. The deductible for parking damage cover must be lower than the deductible for collision cover.',
          inputHint: 'Enter an amount between CHF {min} and {max}',
        },
        glass: {
          label: 'Glass Plus (small glass parts)',
          infoText: 'Partially comprehensive insurance only covers breakage of the front, side and rear windows and a glass sunroof. This also includes materials that serve as a substitute for glass (glass breakage Basis). <br><br> Glass breakage Plus<br> Breakage of all vehicle parts made of glass is insured (including small glass parts such as headlights, indicators, etc.). This also includes materials that serve as a substitute for glass. The insurance also covers light bulbs and light-emitting diodes (LEDs) that are destroyed as a result of glass breakage.',
        },
        personal_effects_coverage: {
          label: 'Value of personal effects in vehicle in CHF',
          infoText: 'The insurance covers occupants personal effects that are stolen in or from the locked vehicle or are damaged as a result of insured damage to the vehicle. Simpego will cover the cost of repair up to the agreed sum insured, or the cost of a replacement in the event of a total loss.',
        },
        free_garage: {
          label: 'Claims repair model',
          infoText: 'Partner garage repair model<br><br>You undertake to notify us of any accidental damage claims before repair work is performed and to have the repair work in carried out at a <a href="https://blog.simpego.ch/en/partner-garages/" target="blank">Partner garage</a>. In return, you benefit from lower comprehensive insurance premiums. If you do not keep to the agreement in the event of a claim, the contract will be changed to the “free choice of garage” repair model and you will have to make a back-payment for the difference in premium for a maximum period of one year.<br><br><br>Free choice of garage repair model <br><br>You can choose the garage you want to perform the repair work yourself.',
          options: {
            true: 'Free choice of garage repair model',
            false: 'Partner garage repair model',
          },
        },
        suspension: {
          label: 'In the case of suspension',
          text: 'No premium refund',
          infoText: 'If you surrender your licence plates temporarily, the premium will not be refunded proportionally.',
        },
        protective_clothing: {
          label: 'Protective clothing at replacement value (including for passengers)',
          infoText: 'In connection with an event covered by comprehensive insurance, the protective clothing of the driver and any passengers is insured at replacement value. Protective clothing includes helmets, goggles, gloves, boots, protectors, one-piece suits and protective suits.',
          fieldName: 'Protective clothing',
        },
      },
      passenger_accident: {
        label: 'Accident insurance',
        labelHint: 'All occupants, benefits per person, medical expenses insured',
        infoText: 'Our accident insurance protects you and all occupants against financial consequences if you have an accident with the insured vehicle.<br><br> The following applies for all types: Medical expenses (private). There are variations in cover for daily compensation, disability capital and death benefit.<br><br> Standard: Daily compensation CHF {DexCarM_daily_compensation}, Disability capital CHF {DexCarM_disability_capital}, Death benefit CHF {DexCarM_death_benefit}<br><br> Basis: Daily compensation CHF {DexCarL_daily_compensation}, Disability capital CHF {DexCarL_disability_capital}, Death benefit CHF {DexCarL_death_benefit}<br><br> Plus: Daily compensation CHF {DexCarXl_daily_compensation}, Disability capital CHF {DexCarXl_disability_capital}, Death benefit CHF {DexCarXl_death_benefit}<br><br> All benefits apply per person. The benefits are paid immediately, i.e. before culpability has been determined. The benefits for disability and death are paid in addition to the benefits under liability insurance and other accident insurance.<br><br> If a pet inside the vehicle is injured, we will cover the treatment costs up to CHF 2´500 per animal and up to a maximum of CHF 5´000 per event.',
      },
      negligence: {
        label: 'Gross negligence',
        infoText: 'We also provide full insurance cover for accidents caused by gross negligence, such as if you are momentarily distracted or you fail to notice a red traffic light. In these situations, we waive our right of recourse and right of reduction. However, this does not apply if the ability to drive was impaired due to alcohol, drugs or substance abuse.',
      },
      assistance24: {
        label: '24h assistance',
        infoText: 'Our services offer you peace of mind in case of breakdowns and accidents: We organise and cover the cost of local assistance for breakdowns and accidents, as well as replacement transport.<br><br> Assistance Basis and Plus also cover the following:<br> Breakdown assistance, towing and vehicle recovery to the nearest suitable garage (Basis), vehicle recovery to a garage of your choice (Plus), accommodation costs, travel expenses, return of the vehicle, replacement transport (rental/replacement vehicle, public transport, taxi) up to CHF 1´500 (Basis) or CHF 4´000 (Plus), notification service.',
      },
      daily_termination: {
        label: 'Cancel any time',
      },
      payment_frequency: {
        label: 'Payment type',
        infoText: 'You can pay your premium either half-yearly or yearly in advance. If you choose not to pay on a yearly basis, an additional surcharge applies.',
      },
      payment_type: {
        label: 'Payment type',
        invoice: 'Invoice',
        creditCard: 'Credit card',
      },
      document_delivery: {
        label: 'Document delivery',
        infoText: 'You will be sent all documents electronically.',
        email: 'Electronically by e-mail',
      },
      taxesTotal: {
        label: 'Taxes and duties',
        infoText: 'Taxes and duties comprise the following: <br> - Stamp duty 5% of the premium for liability and comprehensive insurance<br> - Swiss Road Traffic Act (SVG) levy of CHF 4.20 (according to Articles 74 and 76a SVG, applied to the liability premium)<br> - Accident prevention contribution 0.75% of the liability premium',
      },
      priceTotal: {
        label: 'Total annual premium',
        infoText: 'Your premium based on the selected payment method, including all taxes, duties and fees',
      },
      errors: {
        vehicleLeasing: 'Collision cover is required for leased vehicles.',
      },
    },
    customized: 'Customised',
    comprehensives: {
      notWanted: "Don't want",
      liability: 'Liability',
      partially_comprehensive: 'Partially comprehensive',
      fully_comprehensive: 'Fully comprehensive',
    },
  },
  vehicleSelect: {
    basics: {
      initialRegistrationYear: 'First registered',
      chooseCar: {
        text: 'Select vehicle',
        infoText: 'Please select your vehicle as accurately as possible. If the vehicle type differs slightly, this is not usually a problem and will not affect the insurance premium. The driver and vehicle licensing office will provide us with the exact details of your vehicle upon registration. If the vehicle type differs significantly, we will contact you.',
      },
    },
    comfort: {
      brand: 'Make',
      model: 'Model',
      fuelType: 'Fuel',
      vehicleCategory: 'Category',
      vehiclePower: 'Horsepower',
      transmission: 'Transmission',
    },
    vehicleNumber: {
      typeCertificateNumber: {
        label: 'Vehicle reg. certificate',
        placeholder: '24th digit on the vehicle reg. certificate',
      },
    },
    selected: {
      headline: {
        text: 'Your selected vehicle',
        infoText: 'Please select your vehicle as accurately as possible. If the vehicle type differs slightly, this is not usually a problem and will not affect the insurance premium. The driver and vehicle licensing office will provide us with the exact details of your vehicle upon registration. If the vehicle type differs significantly, we will contact you.',
      },
      btn1: 'Select new vehicle',
      btn2: 'Apply vehicle',
    },
  },
  vehicleData: {
    headline: 'Vehicle details',
    ownedSince: {
      label: 'Owned since',
      infoText: 'Please specify how long you have owned the vehicle.',
    },
    canton: {
      label: 'Canton of registration',
      infoText: 'Please specify the canton in which the vehicle will be registered.',
    },
    businessUsage: {
      label: 'Is the vehicle used for business travel?',
      infoPerson: 'Do you also use the vehicle on behalf of your employer (e.g. for sales visits)?',
      infoCompany: 'Do you also use the vehicle for business purposes?',
    },
    transport: {
      label: 'Is the vehicle used for the commercial or professional transportation of people or goods?',
      infoText: 'The vehicle is considered to be used for commercial or professional purposes if your (business) interests pursue the aim of generating profit through the transportation of goods or people.',
    },
    leasing: {
      label: 'Leasing',
      infoText: 'Please specify whether the vehicle is leased. Please note that fully comprehensive insurance is generally required for a leased vehicle.',
    },
    startOfInsurance: {
      label: 'Desired insurance start date',
      infoText: 'Select your desired insurance start date here. Your insurance will start on this date.',
    },
    errors: {
      vehicleLeasing: 'Collision cover is required for leased vehicles. We have adapted your cover accordingly.',
    },
    vehicleRegistrationType: {
      label: 'The vehicle will be registered as',
      info: 'Please specify whether the vehicle will be registered as a van or a car.',
      car: 'Car',
      van: 'Van',
      carOrVan: 'Car / van',
      motorbike: 'Motorbike',

    },
    truckExtEquipment: {
      label: 'Does the vehicle have any external modifications?',
      info: "External modifications include structures permanently attached to the vehicle (e.g. box bodies, flatbeds, tippers, etc.) that are exclusively intended for use with the insured vehicle and are not included in the vehicle's list price. External modifications do not include items transported in the vehicle.",
      inputHint: 'Specify a value between CHF 0 - 999´999',
      fieldName: 'Value of external modifications',
    },
    truckIntEquipment: {
      label: 'Does the vehicle have any internal modifications?',
      info: "Internal modifications include permanent installations inside the van (e.g. for service vehicles, caretaker services, etc.) that are exclusively intended for use with the insured vehicle and are not included in the vehicle's list price. Internal modifications do not include items transported in the vehicle.",
      inputHint: 'Specify a value between CHF 0 - 999´999',
      fieldName: 'Value of external modifications',
    },
  },
  owner: {
    headline: 'Details of owner',
    nationality: {
      label: 'Nationality',
      infoText: 'Please make sure that you identify yourself with the same nationality at the driver and vehicle licensing office.',
    },
    residencePermit: {
      label: 'Residence permit',
      infoText: 'Specify what type of residence permit you hold.',
      B1: 'B',
      C: 'C',
      L: 'Other',
    },
    driverLicenceSinceYear: {
      label: 'Driving licence since (year)',
      infoText: 'Please specify how long you have been permitted to drive a car. You must be at least 17 years old.',
    },
    isKeeperMainDriver: {
      label: 'Is the vehicle owner the main driver?',
      infoText: 'Please specify whether someone other than you, the vehicle owner, is the main driver.',
    },
    youngDriver: {
      label: 'Does anyone under the age of 25 use the vehicle?',
      infoText: 'Please specify whether anyone under the age of 25 uses the vehicle.',
      youngDriverOptions: {
        male: 'Yes, male',
        female: 'Yes, female',
        both: 'Yes, both',
      },
    },
    driverLicenceWithdrawal: {
      label: 'In the last five years, have you had your driving licence revoked for more than three months, had a policy cancelled or had an application rejected?',
      labelMainDriver: 'In the last five years, have you or the main driver had your driving licence revoked for more than three months, had a policy cancelled or had an application rejected?',
      infoPerson: 'Please specify whether, in the last five years, you have had your driving licence revoked, had a policy cancelled, had an application rejected or had the continuation of a policy made subject to stricter terms and conditions.',
      infoCompany: 'Please specify whether, in the last five years, have you had a policy cancelled, had an application rejected or had the continuation of a policy made subject to stricter terms and conditions.',
      infoMainDriver: 'Please specify whether, in the last five years, you or the main driver have had your driving licence revoked, had a policy cancelled, had an application rejected or had the continuation of a policy made subject to stricter terms and conditions.',
    },
    policyCancelledOrRejected: {
      label: 'Have you had a policy cancelled or an application rejected in the last five years?',
    },
    tooManyAccidents: {
      label: 'Have you made three or more claims in the last three years?',
      labelMainDriver: 'Have you or the main driver made three or more claims in the last three years?',
      infoText: 'Declare all claims in the last three years for which your insurance has paid out. For example, liability claims, collision damage, parking damage, marten damage, glass damage, etc.',
      infoMainDriver: "Declare all claims in the last three years for which your own insurance or the main driver's insurance has paid out. For example, liability claims, collision damage, parking damage, marten damage, glass damage, etc.",
    },
  },
  personalData: {
    headline: {
      agent: 'Broker details',
      person: 'Personal details',
      personForAgent: 'Personal details of the customer',
    },
    agentEmail: {
      label: 'Broker e-mail',
    },
    customerDocuments: {
      label: 'Recipient of customer documents',
      infoText: 'Please select whether the documents should be sent only to you or directly to the customer with you copied in.<br><br> This concerns the following documents: <br> - Contract documents incl. first invoice <br> - Renewal documents incl. invoice',
      toAgent: 'Only to broker',
      toCustomer: 'Only to customer',
      toCustomerAndAgent: 'To customer cc broker',
    },
    invoices: {
      label: 'Recipients of the subsequent invoices during the year',
      infoText: 'Please select whether the invoices should be sent only to you or directly to the customer with you copied in. <br> The following invoices are affected: subsequent invoices during the year. The dispatch control of the subsequent invoices during the year is also used to control the dispatch of credit card e-mails (e.g. registration, non-possible debiting or information on expired or invalid credit cards), which is why ‘only to customer’ is selected for the credit card payment type and cannot be changed.',
      toAgent: 'Only to broker',
      toCustomer: 'Only to customer',
      toCustomerAndAgent: 'To customer cc broker',
    },
    reminders: {
      label: 'Recipient of collection documents',
      infoText: 'Please select whether the documents should be sent only to you or directly to the customer with you copied in. This concerns the following documents:<br> - Friendly Reminder <br> - Reminder <br> - Dunning notices (The dunning letter is always also sent directly to the customer by post)',
      toAgent: 'Only to broker',
      toCustomer: 'Only to customer',
      toCustomerAndAgent: 'To customer cc broker',
    },
    agentMailsDelivery: {
      label: 'Recipient of e-mails',
      infoText: 'E-mails sent from the online sales funnel will be sent to the displayed broker e-mail address, if intermediary or customer cc intermediary is selected. <br>  If "customer" is selected, the mails are only sent to the customer<br><br>Affected mails:<br> - Quote e-mails <br> - Confirmation that insurance taken out<br> - Confirmation that insurance certificate issued<br> - Any follow-up e-mails',
      dispatchDocumentOptions: {
        option1: 'To customer cc broker',
        option2: 'Only to broker',
        option3: 'Only to customer',
      },
      toAgent: 'Only to broker',
      toCustomer: 'Only to customer',
      toCustomerAndAgent: 'To customer cc broker',
    },
    btn: 'Check entries',
    errors: {
      zipCode: 'Please specify a valid postcode.',
    },
    industry: {
      infoText: 'Please specify your industry as per the commercial register entry.',
    },
    emailInfoText: 'We need this information to open a customer file. All e-mails related to this quote (e.g. quote or follow-up e-mails) or the confirmation that insurance has been taken out (insurance confirmation e-mail) will be sent to the broker e-mail address selected above, not to the customer. Please use the "Recipient of customer documents" field to specify where the documents should be sent after the policy has been issued".',
    warningAgentEmail: 'Please check your entry. The customer email address cannot be the same as one of your agent email addresses.',
  },
  priceBox: {
    tariffOptions: {
      liabilityDeductible: 'Liability <em>deductible (CHF {deductible})</em>',
      partiallyComprehensiveDeductible: 'Partially comprehensive <em>deductible (CHF {deductible})</em>',
      fullyComprehensiveDeductible: 'Collision <em>deductible (CHF {deductible})</em>',
      parkDamageDeductible: 'Parking damage <em>deductible (CHF {deductible})</em>',
      freeGarage: 'Repair model: <em>{free_garage}</em>',
      protectiveClothing: 'Protective clothing <em>(CHF {value})</em>',
      glass: 'Glass Plus (small glass parts)',
      personalEffectsCoverage: 'Personal effects in vehicle (CHF {coverage})',
      parkDamage: 'Parking damage cover <span class="{bundleClass}">{bundle}</span>',
      passengerAccident: 'Accident insurance <span class="{bundleClass}">{bundle}</span>',
      grossNegligence: 'Gross negligence',
      assistance24: '24h assistance <span class="{bundleClass}">{bundle}</span>',
      dailyTermination: 'Cancel any time',
    },
    pricePerYear: '{price} /year',
    pricePerKm: '{price} /km',
    maxPerYear: 'max. {price} CHF /year',
    exactKm: 'accurate to the kilometre',
  },
  checkout: {
    headline: {
      h3: 'Summary of your quote',
      text: "Just one more click and your car will be insured with us. 'Please check the entered details again now.",
    },
    summary: {
      basics: {
        headline: 'General insurance details',
        pricePerYear: 'Year',
        startOfInsurance: 'Insured from',
        priceWithKmPremium: '{fix}/year + {perKm}/km, max. {max}/year',
        onlyKmPremium: '{perKm}/km, max. {max}/year',
      },
      car: {
        headline: 'Vehicle details',
        registrationType: 'Registration type',
        truckEquipmentLabel: 'Internal and external modifications',
      },
      payment: {
        billingModel: 'Billing model',
        headline: 'Payment information',
        billEmail: 'Invoice by e-mail',
        documentsEmail: 'Electronically by e-mail',
        creditCard: 'Credit card',
        monthly: 'Monthly',
        yearly: 'Yearly',
        half_yearly: 'Half-yearly',
        quarterly: 'Quarterly',
      },
      checkoutlegal_checkbox: {
        agent: {
          part1: 'I confirm that the customer has acknowledged and accepted the',
          part2: 'General Terms & Conditions of Insurance',
          part3: 'and',
          part4: 'product information',
          part5: 'that apply to the customer. I also confirm that I am authorised to conclude this contract or that I have a corresponding signed mandate. Furthermore, I confirm that I have fulfilled the disclosure requirements towards the customer in accordance with Article 45 of the Swiss Insurance Supervision Act (VAG).',
        },
        person: {
          part1: 'Yes, I would like to take out insurance online and confirm that I have acknowledged and I accept the',
          part2: 'General Terms & Conditions of Insurance',
          part3: 'and the',
          part4: 'product information.',
          part5: 'have taken note of and accept.',
        },
        payment: {
          billingModel: 'Billing model',
        },
      },
      btn: {
        signContact: 'Conclude contract',
        requestProposal: 'Request quote',
      },
      consultationProtocol: {
        input: 'Upload of the consultation protocol or client mandate',
        tooltip: 'You have the option of uploading your consultation protocol or customer mandate here. This is then transferred to simpego together with the quote request and stored with the respective quote. If you calculate several quotation variants, the uploaded document is displayed for each quotation and you have the option of deleting it and uploading a new one.',
        clear: 'Empty input field',
        errors: {
          size: 'The size of the document must not exceed 5MB.',
          type: 'Permitted formats for the document are: pdf, jpeg, png.',
        },
      },
      tariffOptions: {
        liabilityDeductible: 'Liability deductible (CHF {deductible})',
        partiallyComprehensiveDeductible: 'Partially comprehensive deductible (CHF {deductible})',
        fullyComprehensiveDeductible: 'Collision deductible (CHF {deductible})',
        parkDamageDeductible: 'Parking damage deductible (CHF {deductible})',
        protectiveClothing: 'Protective clothing (CHF {value})',
        glass: 'Glass Plus (small glass parts)',
        freeGarage: 'Repair model: {free_garage}',
        personalEffectsCoverage: 'Personal effects in vehicle (CHF {coverage})',
        parkDamage: 'Parking damage cover {bundle}',
        passengerAccident: 'Accident insurance {bundle}',
        grossNegligence: 'Gross negligence',
        assistance24: '24h assistance {bundle}',
        dailyTermination: 'Cancel any time',
        suspension: 'In the case of suspension: premiums are not reimbursed',
      },
    },
    errors: {
      applyContract: 'An error occurred.',
      requestProposal: 'An error occurred. Please try again.',
    },
    specialConditions: {
      payPerKM: {
        title: 'Special Terms & Conditions: Car FlexDrive',
        conditions: [
          {
            text: 'In the event of discrepancies between the General Terms & Conditions of Insurance and these Special Terms & Conditions, the latter shall prevail.',
          },
          {
            headline: 'What is Car FlexDrive:',
            text: 'With FlexDrive, a portion or the full premium for your insurance policy is based on the number of kilometres you actually drive with the insured vehicle. The corresponding premium for the kilometres driven is specified in the insurance policy.  If a fixed premium is agreed, this is payable regardless of the number of kilometres driven.',
          },
          {
            headline: 'Maximum amount per year:',
            text: 'The maximum premium per year is specified in your insurance policy. Once the maximum amount is reached, no further premiums will be charged for the remainder of the insurance year, as long as the contract is not changed.',
          },
          {
            headline: 'Payment of premiums and consequences of non-payment:',
            text: 'The credit card registered in the autoSense app is charged once a month. The charge includes the premium for the kilometres driven in the previous month, and one-twelfth of any applicable fixed premium. The charged amount includes taxes, levies and fees. For each charge, Simpego will send you an invoice electronically. The invoice will include the number of kilometres driven, the corresponding premium and any applicable fixed premium. If the amount due cannot be charged to the credit card registered in the autoSense app within 30 days, Simpego reserves the right to demand immediate payment of the maximum amount specified in the contract. We will send you an invoice for the maximum amount. The premiums already paid for this insurance year will be deducted from the maximum amount. No further premiums will be charged for the remaining contract term, provided that the contract is not changed.',
          },
          {
            headline: 'Receivables relating to claims:',
            text: 'For deductibles and recoveries relating to claims, we will send you an invoice. These amounts will not be charged to your credit card.',
          },
          {
            headline: 'Terms and conditions for using Car FlexDrive:',
            text: 'When using FlexDrive, you agree to not remove the autoSense vehicle adapter from the vehicle for the duration of the contract period, or to only do so in justified cases.',
          },
          {
            headline: 'Disconnects:',
            text: "If the autoSense adapter is removed from the vehicle, this is referred to as a 'disconnect'. autoSense notifies Simpego of a disconnect, as well as the 'connect' when the adapter is reconnected. If the vehicle has been driven for more than 100 meters after the adapter has been disconnected (difference in the vehicle's mileage between a disconnect and a connect), Simpego may request a written explanation from you. Simpego also reserves the right to stop per-kilometre billing after a disconnect. In such case, the maximum amount specified in the contract will become payable immediately. The premiums already paid for this insurance year will be deducted from the maximum amount. No further premiums will be charged for the remaining contract term, provided that the contract is not changed. We will send you an invoice for the maximum amount. These amounts will not be charged to your credit card.",
          },
          {
            headline: 'Surrender of licence plates (suspension):',
            text: 'For FlexDrive insurance policies that include a fixed premium, nothing changes if the licence plates are registered with the driver and vehicle licensing office but the insured vehicle remains in your possession. The fixed premium is still payable even if the licence plates have been surrendered (stationary risks cover). FlexDrive insurance policies that do not include a fixed premium will be cancelled as of the date that the licence plates are surrendered.',
          },
          {
            headline: 'Cancellation and billing:',
            text: 'If the contract is cancelled by you or Simpego, the cancellation will be effective as of the date reported by the driver and vehicle licensing office. Your credit card linked to the autoSense app will only be charged for the kilometres driven until the cancellation of the contract and for the proportionate amount of any applicable fixed premium. The maximum amount is always payable after cancellation in the following two cases: 1. You cancel the contract due to a partial loss during the first year of insurance and Simpego has paid out for the loss; 2. The contract is cancelled due to a total loss (and the consequent elimination of the insured risk) and Simpego has paid out for the loss. The premiums already paid for this insurance year will be deducted from the maximum amount. Following cancellation, we will send you an invoice for the maximum amount. These amounts will not be charged to your credit card.',
          },
          {
            headline: 'Exchange of data between autoSense and Simpego:',
            text: 'From the moment the contract is activated, the following data is exchanged between autoSense AG and Simpego Versicherungen AG:',
          },
          {
            text: 'Simpego notifies autoSense of: contract status, insurance cover, status of insurance cover, information about the insured vehicle, premium to be charged for the previous month.',
          },
          {
            text: 'autoSense notifies Simpego of: adapter status (disconnect / connect), kilometres driven within the local coverage area according to the General Terms & Conditions of Insurance, transaction code of the payment.',
          },
          {
            text: 'No information about your driving behaviour, your location, the vehicle location or any claims will be shared between Simpego and autoSense.',
          },
        ],
        privacy: {
          part1: 'More information about data protection at Simpego can be found in the €žPrivacyâ€œ section of our ',
          part2: 'product information',
          part3: '.',
        },
      },
      kasko2go: {
        title: 'Special Terms & Conditions: kasko2go powered by Simpego',
        conditions: [
          {
            text: 'In the event of discrepancies between the General Terms & Conditions of Insurance and these Special Terms & Conditions, the latter shall prevail.',
          },
          {
            headline: 'What is kasko2go powered by Simpego',
            text: 'With kasko2go powered by Simpego, a portion or the full premium of your insurance policy is based on the number of kilometres driven with the insured vehicle and on a score (rating) of your driving behaviour calculated by kasko2go. If a fixed premium is agreed, this is payable regardless of the number of kilometres driven and the kasko2go score.',
          },
          {
            headline: 'Maximum amount per year',
            text: 'The maximum premium per year is specified in your insurance policy. Once the maximum amount is reached, no further premiums will be charged for the remainder of the insurance year, as long as the contract is not changed.',
          },
          {
            headline: 'Payment of premiums and consequences of non-payment',
            text: 'The credit card registered in the kasko2go app is charged once a month. The charge includes the premium for the kilometres driven in the previous month, and one-twelfth of any applicable fixed premium. The charged amount includes taxes, levies and fees. If the amount due cannot be charged to the credit card registered in the kasko2go app within 10 days, Simpego reserves the right to demand immediate payment of the maximum amount specified in the contract. You will receive a corresponding invoice. The premiums already paid for this insurance year will be deducted from the maximum amount. There will be no further premium charges, per-kilometre billing or consideration of the kasko2go score for the remaining contract term, provided that the contract is not changed.',
          },
          {
            headline: 'Receivables in connection with claims',
            text: 'For deductibles and recoveries relating to claims, we will send you an invoice. These amounts will not be charged to your credit card.',
          },
          {
            headline: 'Terms and conditions for using kasko2go powered by Simpego and consequences of non-compliance',
            text: 'When using kasko2go powered by Simpego, you commit to ensuring that every journey which the insured vehicle is used for is measured by the respective driver using the kasko2go app. The device must be switched on and the kasko2go app activated for this purpose. You are also obliged to declare the mileage of the insured vehicle in the kasko2go app once a month. Simpego reserves the right to request a photo of the current mileage from you at any time. If you fail to provide the requested photographic evidence despite repeated requests, Simpego has the right to demand immediate payment of the maximum amount. The premiums already paid for this insurance year will be deducted from the maximum amount. There will be no further premium charges, per-kilometre billing or consideration of the kasko2Go score for the remaining contract term, provided that the contract is not changed.',
          },
          {
            headline: 'Differences in mileage',
            text: 'If discrepancies are found between the mileage reported by you in the kasko2go app and the mileage measured by the kasko2go app, Simpego has the right to demand immediate payment of the maximum amount.  The premiums already paid for this insurance year will be deducted from the maximum amount. There will be no further premium charges, per-kilometre billing or consideration of the kasko2go score for the remaining contract term, provided that the contract is not changed.',
          },
          {
            headline: 'Surrender of licence plates (suspension)',
            text: 'For kasko2go powered by Simpego insurance policies that include a fixed premium, nothing changes if the licence plates are registered with the driver and vehicle licensing office but the insured vehicle remains in your possession. The fixed premium is still payable even if the licence plates have been surrendered (stationary risks cover). kasko2go powered by Simpego insurance policies that do not include a fixed premium will be cancelled as of the date that the licence plates are surrendered.',
          },
          {
            headline: 'Cancellation and billing',
            text: 'If the contract is cancelled by you or Simpego, the cancellation will be effective as of the date reported by the driver and vehicle licensing office. Your credit card linked to the kasko2go app will only be charged for the kilometres driven until the cancellation of the contract and for the proportionate amount of any applicable fixed premium. The maximum amount is always payable after cancellation in the following two cases: 1. You cancel the contract due to a partial loss during the first year of insurance and Simpego has paid out for the loss; 2. The contract is cancelled due to a total loss (and the consequent elimination of the insured risk) and Simpego has paid out for the loss. The premiums already paid for this insurance year will be deducted from the maximum amount. Following cancellation, we will send you an invoice for the maximum amount. These amounts will not be charged to your credit card.',
          },
          {
            headline: 'Exchange of data between kasko2go and Simpego',
            text: 'From the moment the contract is activated, the following data is shared between kasko2go AG and Simpego Versicherungen AG:',
          },
          {
            text: 'Simpego notifies kasko2go of the contract status, insurance cover, premium information and details of claims relating to the insured vehicle (date of claim, type of claim, description of damage, amount).',
          },
          {
            text: 'kasko2go notifies Simpego of the kilometres driven within the local coverage area according to the General Terms & Conditions of Insurance, the transaction code of the payment, the monthly driving behaviour score, all data about the policyholder, driver(s), insured vehicle and the covered risks that is collected in relation to the application and the issuance of the contract.',
          },
          {
            text: 'Except for the final score, no other information about your driving behaviour, your location, the vehicle location or any other data not mentioned here will be exchanged between Simpego and kasko2go.',
          },
        ],
        privacy: {
          part1: 'More information about data protection at Simpego can be found in the €žPrivacyâ€œ section of our ',
          part2: 'product information',
          part3: '.',
        },
      },
    },
  },
  offer: {
    headline: 'Your quote is on its way!',
    text: 'Thank you for your interest in taking out car insurance with Simpego. We have sent your requested quote to the e-mail address provided. Please check your inbox.',
    mailText: 'If you have any questions, please feel free to contact us',
  },
  confirmation: {
    headline: 'Thank you for taking out insurance with us. Welcome to the Simpego family!',
    headlineText: 'To activate your new car insurance, we still need a few more details from you:',
    form: {
      licencePlateAvailable: 'Do you already have a licence plate for this vehicle?',
      licencePlate: 'What is your licence plate number?',
      licencePlateActive: 'Is this licence plate currently registered and in use?',
      vehicleRegisteredToOwner: 'Is the vehicle {vehicleModel} currently registered under {policyholder}?',
      licencePlateRegisteredToOwner: 'Is this licence plate currently registered under {policyholder}?',
      defaultPolicyholder: 'the policyholder',
      registeredToDextra: 'Have you previously had insurance with Simpego for this vehicle?',
      serialNumber: {
        text: "Please provide the master number of vehicle to be insured. If you don't know the master number of vehicle or don't have it to hand please click the 'Enter information later' button. The insurance confirmation e-mail that we have already sent you contains a link to access this page again.  You can use this link to provide the missing information at a later time.<br><br>Please note that we need the correct master number of vehicle before we can issue an insurance certificate.",
        label: 'Master number of vehicle',
      },
      btn: {
        submit: 'Request insurance certificate',
        infoLater: 'Enter information later',
      },
      infoLaterPopup: 'If you wish to provide the information at a later time, that is not a problem. We have already sent you an insurance confirmation e-mail, which includes a link to this page. By clicking on the link, you can return to this page at any time to provide the missing information.<br>If you have any questions, please feel free to contact us at <a href="mailto:service@simpego.ch">service@simpego.ch</a>',
      inputTypeQuestions: 'Determine reason for registration',
      inputTypeDirect: 'Select registration reason',
    },
    ivReason: {
      label: 'Registration reason',
      new: '57 - New registration',
      reactivation: '52 - Reactivation',
      vehicleChange: '58 - Change of vehicle',
      ownerChange: '59 - Change of owner',
      insurerChange: '54 - Change of insurance provider',
      none: 'No insurance certificate needed',
    },
  },
  infoLater: {
    headline: 'Enter information later.',
    text: 'If you wish to provide the information at a later time, that is not a problem. We have already sent you an insurance confirmation e-mail, which includes a link to this page. By clicking on the link, you can return to this page at any time to provide the missing information.',
    emailText: 'If you have any questions, please feel free to contact us',
    btn: 'Enter information',
  },
  offerExpired: {
    headline: 'Sorry, the provided quote is no longer valid.',
    text1: 'If you have any questions, please feel free to contact our team at the Customer Solution Center, who will be happy to assist you.',
    text2: 'Mon to Thu: 7.30 a.m. – 6.00 p.m. and Fri: 7.30 a.m. – 5.00 p.m. on: +41 58 521 11 11',
    mailText: 'or by e-mail ',
    text3: 'You can also request a new quote:',
    newInsuranceRequest: 'Recalculate premium now',
  },
  rejected: {
    headline: 'Info',
    text1: 'Your quote is already being processed, which is why the link in your e-mail is no longer active. If you have any questions, please feel free to contact our team at the Customer Solution Center, who will be happy to assist you.',
  },
  finish: {
    headline: "Welcome to Switzerland's best* car insurance!",
    text1: 'Thank you for providing your details. What happens next?',
    list1: 'Now that we have your master number of vehicle, we will send out the electronic insurance certificate to the relevant driver and vehicle licensing office. You will then be able to register your vehicle.',
    list2: 'Once you have registered your vehicle, you will receive your insurance documents and the premium invoice from us.',
    hint: "* We hope that's convinced you!",
    homeButton: 'Back to home page',
  },
  declined: {
    headline: 'Info',
    text1: 'Unfortunately, we are unable to offer you insurance for your vehicle at present.',
    text2: 'Thank you for your understanding.',
    back: 'Back',
    reason: 'Reason:',
    defaultReason: 'Quote not possible',
  },
  errorPage: {
    headline: 'Info',
    customerText: 'An error occurred. Please contact customer services.',
    agent: {
      text1: 'Sorry, we encountered a problem accessing your personalised online funnel.',
      text2: 'This may be because:',
      text3: '- There is a technical issue with the page.',
      text4: '- Your broker profile is still awaiting activation internally at Simpego.',
      text5: '- Your broker profile has been suspended.',
      mail: 'Please report this error to our Customer Solution Center by e-mail',
      tel: 'or by phone on +41 58 521 11 11.',
      text6: 'You can reach us from Mon to Thu: 7.30 a.m. – 6.00 p.m. and Fri: 7.30 a.m. – 5.00 p.m.',
    },
  },
  mediator: {
    mediatorData: 'Broker details',
    mediatorName: 'Broker name / company',
    mediatorID: 'Broker ID',
    refreshWarning: 'Do you want to start a new calculation? (existing data will be lost!)',
    endSessionWarning: 'Do you want to remove your broker authentication? (existing data will be lost)',
  },
  servicePage: {
    headline: "We're taking a pit stop!",
    content: 'This page is currently undergoing maintenance.<br> We are therefore unable to provide you with a price calculation right now.<br> Please try again later – thank you! <br><br> Your Simpego Team',
  },
  validation: {
    messages: {
      required: 'Please answer this question.',
      validate_integer: 'Please enter a correct number.',
    },
    custom: {
      ownedSince: {
        required: 'Please select the year that you bought the car.',
      },
      businessUsage: {
        required: 'Please specify whether you use the car for private or business purposes.',
      },
      canton: {
        required: 'Please select the canton in which the car is to be insured.',
      },
      leasing: {
        required: 'Please specify whether you have leased the car.',
      },
      nationality: {
        required: 'Please specify your nationality.',
      },
      otherNationality: {
        required: 'Please specify your nationality.',
      },
      residencePermit: {
        required: 'Please specify your residence permit.',
      },
      driverLicenceSinceYear: {
        required: 'Please specify how long you have been permitted to drive a car.',
        min: 'Please specify how long you have been permitted to drive a car.',
        between: 'The owner must be at least 18 years old at the time of the check',
      },
      agentEmail: {
        required: 'Please specify your broker e-mail.',
      },
      customerDocuments: {
        required: 'Please specify your document delivery method.',
      },
      gender: {
        required: 'Please specify your title.',
      },
      firstName: {
        required: 'Please specify your first name.',
      },
      lastName: {
        required: 'Please specify your surname.',
      },
      street: {
        required: 'Please specify your street.',
      },
      houseNumber: {
        required: 'Please specify your house number.',
      },
      zip: {
        required: 'Please specify your postcode.',
        digits: 'Please specify a 4-digit postcode.',
        validate_zipcode: 'Please specify a valid postcode.',
      },
      city: {
        required: 'Please specify your town/city.',
      },
      email: {
        required: 'Please specify your e-mail.',
        email: 'Please specify a valid e-mail address.',
        validate_email: 'Please specify a valid e-mail address.',
        umlaut_email: 'The e-mail address is not valid, it must not contain ä, ö or ü.',
      },
      age: {
        required: 'Please specify your age.',
        validate_ageOrYear_16: 'Please enter an age between 16 and 99.',
        validate_ageOrYear_18: 'Please enter an age between 18 and 99.',
      },
      nationalitySwiss: {
        required: 'Please specify your nationality.',
      },
      phone: {
        required: 'You have opted for a billing model with tracking (FlexDrive or BonusDrive). Please enter the mobile phone number of the smartphone on which you would like to install the app to track your driving behaviour.',
        validate_mobile_phone: 'You have opted for a billing model with tracking (FlexDrive or BonusDrive). We need the mobile phone number of the smartphone on which you want to install the app to track your driving behaviour. The number provided does not appear to be a (valid) mobile phone number.',
        validate_phone: 'Please check your entry. The telephone number must be between 8 and 13 digits long. The number does not have to be entered.',
      },
      dateOfBirth: {
        required: 'Please specify your date of birth.',
        date_format: 'Please specify the date in the following format: DD.MM.YYYY',
        validate_ageMin: 'You already entered your age in the first step. You cannot be younger than the age you previously specified',
        validate_ageMax: 'You already entered your age in the first step. You cannot be older than the age you previously specified',
      },
      startOfInsurance: {
        required: 'Please specify the insurance start date.',
        after: "The specified date is in the past. 'Please specify a future date.",
        before: 'Please specify a date within the next 12 months.',
        date_format: 'Please specify the date in the following format: DD.MM.YYYY',
      },
      initialRegistrationYear: {
        required: 'Please enter the year that the vehicle was first registered.',
      },
      brand: {
        required: 'Please select the make, then the model.',
      },
      model: {
        required: 'Please select the model in addition to the make.',
      },
      typenumber: {
        required: 'Vehicle not found. Please check your entry or use the vehicle search.',
        digits: 'Vehicle not found. Please check your entry or use the vehicle search.',
      },
      typeCertificateNumber: {
        required: 'Please specify the vehicle reg. certificate.',
        regex: 'Please check the vehicle reg. certificate number (6 digits)',
      },
      licencePlate: {
        required: 'Please specify your licence plate.',
        digits: 'Please check your licence plate.',
        regex: 'Please check your licence plate.',
        between: 'The licence plate number must be between 1 and 999999.',
      },
      partially_comprehensive: {
        park_damage_deductible: {
          max_value: 'The deductible must be at least CHF 100 lower than the deductible in the event of a collision. If the deductible in the event of a collision is CHF 0, then the deductible for parking damage must also be CHF 0.',
        },
        personal_effects_coverage: {
          in: 'Only values of CHF 1´000, CHF 2´000, CHF 3´000, CHF 4´000 or CHF 5´000  are allowed',
        },
        protective_clothing: {
          between: 'The value of protective clothing must be between CHF 0 (= not insured) and CHF 5´000.',
        },
      },
      fully_comprehensive: {
        deductible1: {
          min_value: 'The deductible must be at least CHF 100 higher than the deductible in the event of parking damage.',
          in: 'Please specify the value in increments of CHF 100.',
          between: 'For uninsured parking damage cover, the deductible must be between CHF 0 and CHF 10´000.',
        },
        deductible2: {
          in: 'Please specify the value in increments of CHF 100.',
          between: 'For uninsured parking damage cover, the deductible must be between CHF 500 and CHF 10´000.',
        },
      },
      legal: {
        required: 'To proceed, please confirm that you have acknowledged the mentioned documents.',
      },
      legalAgent: {
        required: 'To proceed, please confirm that the customer accepts the applicable terms & conditions and documents and that you are authorised to conclude this contract.',
      },
      serialNumber: {
        regex: 'Please check the format',
        validate_serial_number: 'Please check that the entered master number of vehicle is correct.',
      },
      youngDriver: {
        validate_driverUnderTwentyfive: 'You have specified that you are under 25 years old, which means you cannot answer this question negatively.',
      },
    },
  },
  rateListItems: {
    liability: 'Liability',
    deductible: 'Deductible CHF&nbsp;{value}',
    partially_comprehensive: 'Partially comprehensive',
    fully_comprehensive: 'Collision cover',
    gross_negligence: 'Gross liability cover',
    passenger_accident: 'Accident <span>{bundle}</span>',
    '24_assistance': '24h assistance <span>{bundle}</span>',
    daily_termination: 'Cancel any time',
    Basis: 'Basis',
    Plus: 'Plus',
    Standard: 'Standard',
    not_covered: 'Not insured',
    unlimited: 'Unlimited',
    yes: 'Yes',
    protective_clothing: 'Protective clothing',
    free_garage: {
      headline: 'Repair model: {value}',
      accordionText: '<p>{free_garage}</p>',
    },
    glass: {
      Basis: 'not insured',
      Plus: 'insured',
    },
    flexDrive: {
      headline: 'FlexDrive',
      accordionText: 'Billing to the exact kilometre according to actual kilometres driven. The choice between the billing models can be made on the following pages ‘Customise coverage’ or in step 3 according to the owner details.',
    },
    DexCarM: {
      liability: '<p>Sum insured:<br>CHF&nbsp;{insuarance_sum_value}&nbsp;million</p><p>Deductible for undeclared drivers under the age of 25:<br>+ CHF&nbsp;{value_under_25}</p>',
      partially_comprehensive: '<p>Glass Plus (small glass parts):<br>{glas_package}</p><p>Personal effects in vehicle:<br>{personal_effects_coverage}</p>',
      fully_comprehensive: '<p>Parking damage cover:<br>{park_damage_value}</p><p>Parking damage deductible:<br>{park_damage_deductible}</p>',
      gross_negligence: '<p>{negligence}</p>',
      passenger_accident: 'Accident Standard',
      '24_assistance': '24h assistance Basis',
    },
    DexCarL: {
      liability: '<p>Sum insured:<br>CHF&nbsp;{insuarance_sum_value}&nbsp;million</p><p>Deductible for undeclared drivers under the age of 25:<br>+ CHF&nbsp;{value_under_25}</p>',
      partially_comprehensive: '<p>Glass Plus (small glass parts):<br>{glas_package}</p><p>Personal effects in vehicle:<br>{personal_effects_coverage}</p>',
      fully_comprehensive: '<p>Parking damage cover:<br>{park_damage_value}</p><p>Parking damage deductible:<br>{park_damage_deductible}</p>',
      gross_negligence: '<p>{negligence}</p>',
      passenger_accident: '<p>Group of persons:<br>All occupants</p><p>Death benefit:<br>{death_benefit}</p><p>Disability capital:<br>{disability_capital}</p><p>Daily compensation and treatment costs:<br>per&nbsp;{daily_compensation}</p>',
      '24_assistance': '<p>Towing to:<br>nearest garage</p><p>Return travel and replacement transport <br> (e.g. replacement/rental vehicle)<br>up to CHF&nbsp;1500</p>',
    },
    DexCarXl: {
      liability: '<p>Sum insured:<br>CHF&nbsp;{insuarance_sum_value}&nbsp;million</p><p>Deductible for undeclared drivers under the age of 25:<br>+ CHF&nbsp;{value_under_25}</p>',
      partially_comprehensive: '<p>Glass Plus (small glass parts):<br>{glas_package}</p><p>Personal effects in vehicle:<br>{personal_effects_coverage}</p>',
      fully_comprehensive: '<p>Parking damage cover:<br>{park_damage_value}</p><p>Parking damage deductible:<br>{park_damage_deductible}</p>',
      gross_negligence: '<p>{negligence}</p>',
      passenger_accident: '<p>Group of persons:<br>All occupants</p><p>Death benefit:<br>{death_benefit}</p><p>Disability capital:<br>{disability_capital}</p><p>Daily compensation and treatment costs:<br>per&nbsp;{daily_compensation}</p>',
      '24_assistance': '<p>Towing to:<br>garage of choice</p><p>Return journey and replacement transport<br> (e.g. replacement/rental vehicle)<br>up to CHF 4´000</p>',
    },
  },
  billingModels: {
    flex_drive: 'FlexDrive',
    flat_rate: 'BasisDrive',
    bonus_drive: 'BonusDrive',
  },
  billingModelChooser: {
    trackingDrivingBehaviour: 'Tracking of driving behaviour',
    chooseBillingModel: 'Select billing model',
    bonusDriveExplanation: '(BasisDrive with tracking of your driving behaviour)',
    headlineInfoText: {
      flex_drive: '<p>The total premium is made up of a fixed premium (stationary risks (partial casco)) and the variable premium (moving risks (collision, liability, gross negligence)). The total premium (CAP) is capped (guaranteed maximum annual premium).</p><br><p>How is the CAP calculated? Fixed premium per year + kilometre premiums for 12,000 kilometres. FlexDrive is billed monthly by credit card.</p><br><p>The kilometres driven per month per insurance year and the score (driving behaviour) are reported via the app. The score can reduce but not increase the kilometre-based premium.</p><br><p>As soon as your policy has been issued, you will receive an SMS and an EMAIL with instructions on how to download the app and register. For simpego FlexDrive you need an activated simpego FlexDrive App. Once you allow the app to observe your trips, it will run in the background. You don’t have to launch the app or do anything special each time that you drive.</p>',
      bonus_drive: "<p>As soon as your contract has been policed, you will receive an SMS and an EMAIL with instructions for downloading the APP and registering.</p><br><p>The simpego FlexDrive APP will run in the background to track how you drive. You may occasionally receive messages reminding you to keep the Wi-Fi switched on or to restart the app if it stops working for any reason. Your ride score will be displayed when you have completed your first 10 rides (see the Trip Tracker map in the app). You can see the list of your previous journeys. Based on your driving performance, your score will be updated and displayed on the main screen of the app. We'll get an idea of what kind of driver you are, help you get better, and get you a discount on your insurance to boot.</p>",
    },
    subline: {
      flex_drive: 'FlexDrive is a kilometre-based billing system where you only pay for the kilometres you actually drive. The total premium is made up of an annual <a href="https://www.simpego.ch/flexdrive-en" target="blank">fixed premium</a>, the <a href="https://www.simpego.ch/flexdrive-en" target="blank">variable premium</a> (premium per kilometre) and the <a href="https://www.simpego.ch/flexdrive-en" target="blank">driving behaviour</a>. Driving behaviour is tracked with an app and converted into a score. This can reduce but not increase the actual premium to be paid per kilometre.',
      flat_rate: 'The premium is set per contract year and is payable in advance. The amount depends on the insured risks and the agreed benefits.',
      bonus_drive: 'The premium is set per contract year and must be paid in advance. The amount depends on the insured risks and the agreed benefits. During the insurance year, you can find out your bonus and receive a discount on your insurance for the next insurance year.',
    },
    trackingDrivingBehaviourInfoText: '<p>Tracking driving behaviour is part of FlexDrive and BonusDrive.</p><br><p>You need the Simpego FlexDrive app to track your driving behaviour. As soon as the contract has been signed, you will receive an SMS and an EMAIL with instructions for downloading the app and registering. As soon as the app is authorised to monitor journeys, it runs in the background. There is no need to restart the app every time or do anything special before setting off. After registering in the app, you will receive all further information by e-mail.</p>',
  },
  productInfoText: {
    DexCarM: 'Our premium for those who want to save money. Everything you need as a driver: Liability, partially comprehensive and fully comprehensive.',
    DexCarL: 'Our most popular product. Benefit from above-average benefits at great premiums, including accident insurance, gross negligence and 24-hour assistance.',
    DexCarXl: 'The insider tip on the market. Our product for all those who value unlimited protection with a minimum deductible. Best conditions for liability, partially comprehensive, fully comprehensive, accident insurance, gross negligence and 24-hour assistance.',
    billingModelInfo: 'You can choose between the billing modell BasisDrive, FlexDrive or BasisDrive with tracking of your driving behaviour. FlexDrive is kilometre-based billing, where you only pay for the kilometres you actually drive. If the car is parked in the garage or you are travelling less, you automatically save on the premium. And thanks to monthly billing, you always have an overview! BonusDrive and FlexDrive are not yet available for motorbikes and corporate customers. <a href="https://blog.simpego.ch/en/car-insurance-billing-models/" target="blank">Further information can be found here</a>',
  },
  file: {
    select: 'Select file',
    clear: 'Clear input field',
  },
}
